import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLocal } from '../utils/localStorageOps';

export const SignUpRoute = ({ children }) => {
  const location = (
    getLocal('zoop_id') ? (
        "/cadastro/passo3"
    ) : (
      "/cadastro/passo1"
    )
  ) 

  return getLocal('nomecadastro') ? children : <Navigate to={location} />
};